<template>
  <div id="program-sekuy">
    <div class="bg-cLightBlue bg-opacity-10 mt-40 px-4 pb-10 md:mt-80 lg:pb-2">
      <h3
        class="karla md:text-xl xl:text-2xl text-cBlue font-semibold text-center tracking-wider pt-10 -mt-20 md:-mt-32 lg:-mt-52 xl:-mt-56"
      >
        PROGRAM SeKuy APA SAJ SIH ?
      </h3>
      <img
        src="../assets/bg-program.svg"
        alt=""
        class="absolute -ml-12 inset-x-2/4 -mt-12"
      />
      <hr
        class="mx-auto w-8/12 md:w-5/12 lg:w-4/12 xl:w-3/12 border mt-3 border-cLightBlue"
      />
      <div class="grid lg:grid-cols-2">
        <div>
          <img
            src="../assets/program.png"
            alt=""
            class="my-8 md:w-10/12 md:mx-auto lg:w-full lg:mt-16 xl:mt-4"
          />
        </div>
        <div class="md:mx-10 lg:my-auto lg:mx-2">
          <ul class="text-sm text-left">
            <li class="bg-cWhiteBase mx-4 lg:my-4">
              <div class="flex my-2">
                <img
                  src="../assets/program-list.svg"
                  alt=""
                  class="ml-4 my-2 lg:my-6 lg:ml-8"
                />
                <p
                  class="ml-2 text-cBlue text-sm my-auto pl-2 pr-4 font-bold lg:text-xl lg:pl-4 lg:pr-8"
                >
                  Menyantuni anak yatim
                </p>
              </div>
            </li>
            <li class="bg-cWhiteBase mx-4 lg:my-4">
              <div class="flex my-2">
                <img
                  src="../assets/program-list.svg"
                  alt=""
                  class="ml-4 my-2 lg:my-6 lg:ml-8"
                />
                <p
                  class="ml-2 text-cBlue text-sm my-auto pl-2 pr-4 font-bold lg:text-xl lg:pl-4 lg:pr-8"
                >
                  MAJU (Makan Jum'at)
                </p>
              </div>
            </li>
            <li class="bg-cWhiteBase mx-4 lg:my-4">
              <div class="flex my-2">
                <img
                  src="../assets/program-list.svg"
                  alt=""
                  class="ml-4 my-2 lg:my-6 lg:ml-8"
                />
                <p
                  class="ml-2 text-cBlue text-sm my-auto pl-2 pr-4 font-bold lg:text-xl lg:pl-4 lg:pr-8"
                >
                  Membantu kaum dhuafa
                </p>
              </div>
            </li>
            <li class="bg-cWhiteBase mx-4 lg:my-4">
              <div class="flex my-2">
                <img
                  src="../assets/program-list.svg"
                  alt=""
                  class="ml-4 my-2 lg:my-6 lg:ml-8"
                />
                <p
                  class="ml-2 text-cBlue text-sm my-auto pl-2 pr-4 font-bold lg:text-xl lg:pl-4 lg:pr-8"
                >
                  Aksi ikut terlibat membantu setiap ada musibah Bencana Alam
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <carousel
      :per-page="4"
      :mouse-drag="false"
      :navigationEnabled="true"
      :loop="true"
      :centerMode="true"
      :paginationEnabled="false"
      class="mx-8 mt-10 md:mt-16"
    >
      <!-- <slide v-for="(slide, i) in dataScroll" :index="i" :key="i">
        <img :src="slide.imgURl" alt="" class="img-modal rounded-md mx-auto" />
      </slide> -->
      <slide>
        <img src="../assets/scroll1.png" alt="" class="px-1 lg:px-3" />
      </slide>
      <slide>
        <img src="../assets/scroll2.png" alt="" class="px-1 lg:px-3" />
      </slide>
      <slide>
        <img src="../assets/scroll3.png" alt="" class="px-1 lg:px-3" />
      </slide>
      <slide>
        <img src="../assets/scroll4.png" alt="" class="px-1 lg:px-3" />
      </slide>
      <slide>
        <img src="../assets/scroll5.png" alt="" class="px-1 lg:px-3" />
      </slide>
      <slide>
        <img src="../assets/scroll6.png" alt="" class="px-1 lg:px-3" />
      </slide>
      <slide>
        <img src="../assets/scroll7.png" alt="" class="px-1 lg:px-3" />
      </slide>
      <slide>
        <img src="../assets/scroll8.png" alt="" class="px-1 lg:px-3" />
      </slide>
      <slide>
        <img src="../assets/scroll9.png" alt="" class="px-1 lg:px-3" />
      </slide>
      <slide>
        <img src="../assets/scroll10.png" alt="" class="px-1 lg:px-3" />
      </slide>
      <slide>
        <img src="../assets/scroll11.png" alt="" class="px-1 lg:px-3" />
      </slide>
      <slide>
        <img src="../assets/scroll12.png" alt="" class="px-1 lg:px-3" />
      </slide>
      <slide>
        <img src="../assets/scroll13.png" alt="" class="px-1 lg:px-3" />
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "Program",
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      dataScroll: [
        { imgUrl: "../assets/scroll1.png" },
        { imgUrl: "../assets/scroll2.png" },
        { imgUrl: "../assets/scroll3.png" },
        { imgUrl: "../assets/scroll4.png" },
        { imgUrl: "../assets/scroll5.png" },
        { imgUrl: "../assets/scroll6.png" },
        { imgUrl: "../assets/scroll7.png" },
        { imgUrl: "../assets/scroll8.png" },
        { imgUrl: "../assets/scroll9.png" },
        { imgUrl: "../assets/scroll10.png" },
        { imgUrl: "../assets/scroll11.png" },
        { imgUrl: "../assets/scroll12.png" },
        { imgUrl: "../assets/scroll13.png" },
      ],
    };
  },
};
</script>

<style>
</style>